import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=63d088d2&scoped=true"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=63d088d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d088d2",
  null
  
)

export default component.exports